module.exports = __webpack_public_path__ + "img/shouyebg1.4a4bc2b6.jpg";